export const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
